import * as React from 'react'
import { Alert, Button, CardBody, CardFooter, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap'
import { FontAwesomeIcon } from '../../../components/ui/FontAwesomeIcon';
import { CommentCodeMoodSelect } from '../../../containers/CommentDetails/lib/CommentCodeMoodSelect';
import { addCommentCode, ICommentCodeIndex, updateCommentCode, ICommentCodeType, getCommentCodeTypes } from '../../../containers/CommentDetails/lib/http';
import { Select } from 'components/ui/Select';

interface ICommentCodeEditorProps {
  editMode?: ICommentCodeIndex
  onSuccess?: () => void
  onCancel?: () => void
}

interface ICommentCodeEditorState {
  commentCode: ICommentCodeIndex
  commentTypeOptions: ICommentCodeType[]
  isInEditMode: boolean
  isSubmitting: boolean
  errorStr?: string
  commentCodeType?: ICommentCodeType
}

export class CommentCodeEditor extends React.Component<ICommentCodeEditorProps, {}> {
  state: ICommentCodeEditorState = {
    isSubmitting: false,
    isInEditMode: false,
    // tslint:disable-next-line:no-object-literal-type-assertion
    commentCode: {} as ICommentCodeIndex,
    commentTypeOptions: [],
    commentCodeType: {} as ICommentCodeType,
  }

  componentWillMount() {
    const { editMode } = this.props

    if (editMode) {
      this.setState({ commentCode: editMode, isInEditMode: true })
    }

    getCommentCodeTypes().then((commentTypeOptions) => this.setState({ commentTypeOptions }))
  }

  onValueChange<K extends keyof ICommentCodeIndex>(key: K, e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | string) {
    const { commentCode } = this.state

    if (typeof e === 'string') {
      // @ts-ignore
      commentCode[key] = e;
    } else {
      commentCode[key] = e.currentTarget.value as ICommentCodeIndex[K]
    }

    this.setState({ commentCode })
  }

  onCommentCodeTypeChange(id: number) {
    const { commentCode, commentTypeOptions } = this.state

    const selectedItem = commentTypeOptions.find((item) => {
      return item.id === id
    })

    commentCode.typeId = id
    if (selectedItem) {
      commentCode.typeLabel = selectedItem.label
    }

    this.setState({ commentCode })
  }

  onSubmit(e: React.FormEvent<HTMLFormElement>) {
    const { commentCode, isInEditMode } = this.state
    const { onSuccess = () => ({}) } = this.props
    let updatePromise = Promise.resolve<any>({});

    e.preventDefault()

    if (isInEditMode) {
      updatePromise = updateCommentCode(commentCode);
    } else {
      updatePromise = addCommentCode(commentCode);
    }

    this.setState({ isSubmitting: true, errorStr: undefined });

    updatePromise
      .then(() => onSuccess())
      .catch((err) => this.setState({ errorStr: err.message }))
      .finally(() => this.setState({ isSubmitting: false }))
  }

  render() {
    const { isSubmitting, errorStr } = this.state
    const { onCancel = () => ({}) } = this.props

    return (
      <Form onSubmit={(e) => this.onSubmit(e)}>
        <CardBody>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>Label (max 50 characters)</Label>
                <Input value={this.state.commentCode.shortLabel} required
                  onChange={(e) => this.onValueChange('shortLabel', e)} />
              </FormGroup>
              <FormGroup>
                <Label>Mood</Label>
                <CommentCodeMoodSelect required
                  onChange={(mood) => this.onValueChange('mood', mood)}
                  value={this.state.commentCode.mood} />
              </FormGroup>
              <FormGroup>
                <Label>Type</Label>
                <Select<ICommentCodeType, 'id'>
                  valueKey="id"
                  labelKey="label"
                  label={this.state.commentCodeType.label}
                  options={this.state.commentTypeOptions}
                  value={this.state.commentCode.typeId}
                  onChange={(e) => this.onCommentCodeTypeChange(e)} />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Description (max 100 characters)</Label>
                <textarea className="form-control" style={{ height: 172 }} required
                  value={this.state.commentCode.longLabel}
                  onChange={(e) => this.onValueChange('longLabel', e)} />
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
        <CardFooter className="d-flex justify-content-end">
          {errorStr &&
            <Alert color="destructive" className="mb-0">
              {errorStr}
            </Alert>
          }
          <Button color="secondary" className="mr-2"
            onClick={() => onCancel()}
            disabled={isSubmitting}>
            <span>Cancel</span>
          </Button>
          <Button color="primary" type="submit"
            disabled={isSubmitting || !!errorStr}>
            <span>Submit&nbsp;</span>
            {isSubmitting &&
              <FontAwesomeIcon icon="cog" spin />
            }
          </Button>
        </CardFooter>
      </Form>
    )
  }
}
